import { useEffect, useState } from 'react';
import { Common } from '@stockbit/ui';
import Paywall from 'features/paywall/Wrapper/Widget';
import { SideWidgetAnalytics as WIDGET } from 'features/paywall/analytics';
import Header from './Header';
import ValuationContent from './ValuationWidget/ValuationContent';
import ScreenerContent from './ScreenerWidget/ScreenerContent';
import { adjustIcon } from 'assets/base64icon';
import { HumbergerButton } from '../styled';
import { Box as ResizableBox } from '../Resizeable/styled';
import { selectors } from './slice';
import { useSelector } from 'react-redux';

const { Flex, IconBase64 } = Common;

interface valuationProps {
  isPro: boolean;
  isProScreener: boolean;
}

function Valuation({ isPro, isProScreener }: valuationProps) {
  const { getValuationTemplateLoad } = useSelector(selectors);
  const { data: valuationData, isLoading } = getValuationTemplateLoad;

  const [isHumbergerValuation, setHumbergerValuation] = useState(false);
  const [isHumbergerScreener, setHumbergerScreener] = useState(false);
  const [isPresetScreener, setPresetScreener] = useState(false);

  const [isUpdateMode, setUpdateMode] = useState(false);

  const [isShowResultSection, setShowResultSection] = useState(false);

  const [screenerTitle, setScreenerTitle] = useState('Screener Title');
  const [resizeableHeight, setResizeableHeight] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);

  // hamburger valuation
  const handleSwitchHumbergerValuation = () => {
    if (isUpdateMode) {
      setUpdateMode(false);
    }

    if (isShowResultSection) {
      setShowResultSection(false);
    }

    setHumbergerValuation(!isHumbergerValuation);
  };

  // hamburger screener
  const handleSwitchHumbergerScreener = () => {
    setPresetScreener(false);
    setHumbergerScreener(!isHumbergerScreener);
  };

  // preset screener
  const handlePresetScreener = () => {
    setHumbergerScreener(false);
    setPresetScreener(!isPresetScreener);
  };

  // off preset and hamburgrer screener
  const handleOffScreenerAndHamburger = () => {
    setHumbergerScreener(false);
    setPresetScreener(false);
  };

  // isPro 1: pro, 0: not pro
  const checkIsProUser = () => isPro;

  const valuationTitle =
    isUpdateMode && valuationData.valuation?.name
      ? valuationData.valuation.name
      : 'Valuation Tool';

  useEffect(() => {
    const resizeable = document.getElementsByClassName('valuation-top');
    if (resizeable.length) {
      setResizeableHeight(resizeable[0].clientHeight);
    }
    setWindowHeight(window.innerHeight);
  }, []);

  return (
    <>
      <ResizableBox
        className="valuation-top"
        defaultSize={{ height: '50%', width: '100%' }}
        maxHeight={windowHeight - 40}
        minHeight={50}
        onResizeStop={(e, direction, ref, d) => {
          const h = resizeableHeight + d.height;
          setResizeableHeight(h);
        }}
        style={{ zIndex: 105 }}
      >
        <Header title={valuationTitle} isLoading={isLoading}>
          {checkIsProUser() && (
            <HumbergerButton
              active={isHumbergerValuation}
              onClick={handleSwitchHumbergerValuation}
            />
          )}
        </Header>
        {checkIsProUser() ? (
          <ValuationContent
            isHumbergerValuation={isHumbergerValuation}
            handleSwitchHumbergerValuation={handleSwitchHumbergerValuation}
            isUpdateMode={isUpdateMode}
            setUpdateMode={setUpdateMode}
            isShowResultSection={isShowResultSection}
            setShowResultSection={setShowResultSection}
          />
        ) : (
          <Paywall height="45vh" source={WIDGET.VALUATION} />
        )}
      </ResizableBox>
      <div
        style={{
          height: `calc(100vh - ${resizeableHeight}px)`,
          position: 'relative',
          zIndex: 106,
        }}
      >
        <Header title={screenerTitle}>
          {isProScreener && (
            <Flex align="center">
              <IconBase64
                icon={adjustIcon}
                iconSize="20px"
                margin="10px"
                onClick={handlePresetScreener}
              />
              <HumbergerButton
                active={isHumbergerScreener}
                onClick={handleSwitchHumbergerScreener}
              />
            </Flex>
          )}
        </Header>
        {isProScreener ? (
          <ScreenerContent
            isHumbergerScreener={isHumbergerScreener}
            isPresetScreener={isPresetScreener}
            handlePresetScreener={handlePresetScreener}
            handleOffScreenerAndHamburger={handleOffScreenerAndHamburger}
            setScreenerTitle={setScreenerTitle}
            maxAutocompleteHeight={`calc(100vh - ${resizeableHeight}px - 150px)`}
          />
        ) : (
          <Paywall height="45vh" source={WIDGET.SCREENER} />
        )}
      </div>
    </>
  );
}

export default Valuation;
